<template>
  <AuthShell ref="auth" mode="recovery">
    <el-form :disabled="submitting || codeBusy" :model="ruleForm" :rules="rules" ref="ruleForm" @submit.native.prevent="submitForm('ruleForm')">
      <label class="auth-label" for="forgetpwd-mobile">手机号</label>
      <el-form-item prop="mobile"><el-input id="forgetpwd-mobile" v-model="ruleForm.mobile" type="tel" autocomplete="tel" placeholder="请输入手机号码" /></el-form-item>
      <label class="auth-label" for="forgetpwd-code">验证码</label>
      <el-form-item prop="code"><div class="auth-code-field"><el-input id="forgetpwd-code" v-model="ruleForm.code" autocomplete="one-time-code" placeholder="请输入验证码" /><el-button class="auth-code-button" :disabled="codeBusy || !!times" @click="getCode">{{ codeBusy ? '发送中…' : typeof showCode === 'number' ? showCode + '秒后重试' : showCode }}</el-button></div></el-form-item>

      <div class="auth-password-grid">
        <div><label class="auth-label" for="forgetpwd-password">新密码</label><el-form-item prop="password"><el-input id="forgetpwd-password" v-model="ruleForm.password" type="password" autocomplete="new-password" placeholder="设置新的登录密码" show-password /></el-form-item></div>
        <div><label class="auth-label" for="forgetpwd-confirm">确认密码</label><el-form-item prop="checkPassword"><el-input id="forgetpwd-confirm" v-model="ruleForm.checkPassword" type="password" autocomplete="new-password" placeholder="再次输入密码" show-password /></el-form-item></div>
      </div>
      <el-button :loading="submitting" :disabled="submitting || codeBusy" type="primary" class="auth-submit" native-type="submit">重置密码</el-button>
    </el-form>
  </AuthShell>
</template>

<script>
import AuthShell from './AuthShell.vue'
import authSecurity from '@/utils/authSecurity'

import {apiForget} from '@/utils/requestapis'
import Router from "@/router";

export default {
  components: { AuthShell },
  mixins: [authSecurity],
  data() {
    var validateCode = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入验证码'));
      } else {
        callback();
      }
    };
    var validateUsername = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入手机号'));
      } else if (value.length < 11) {
        callback(new Error('手机号输入不一致!'));
      } else {
        callback();
      }
    };
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'));
      } else {
        callback();
      }
    };
    var validateCheckPass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'));
      } else {
        if (this.ruleForm.password != value) {
          callback(new Error('输入的确认密码有误'));
        }else {
          callback();
        }
      }
    };
    return {
      showCode:'获取验证码',
      times:false,
      codeBusy:false,
      disposed:false,
      checkList:[],
      activeName:'first',
      ruleForm: {
        mobile: '',
        code: '',
        password:'',
        checkPassword:''
      },
      rules: {
        mobile: [
          { validator: validateUsername, trigger: 'blur' }
        ],
        code: [
          { validator: validateCode, trigger: 'blur' }
        ],
        password: [
          { validator: validatePass, trigger: 'blur' }
        ],
        checkPassword: [
          { validator: validateCheckPass, trigger: 'blur' }
        ]
      }
    };
  },
  beforeDestroy() { this.disposed = true; clearInterval(this.times) },
  methods: {
    getCode2(){
      this.showCode--;
      if(this.showCode <= 0){
        this.showCode = '获取验证码';
        clearInterval(this.times);
        this.times = false;
      }
    },
    async getCode() {
      if (this.submitting || this.codeBusy || this.times) return
      if(!/^\d{11}$/.test(this.ruleForm.mobile)){
          this.$message({
            message: '请输入11位手机号',
            type: 'error',
            duration: 5 * 1000
          })
        return 0;
      }
      let param = {
        mobile:this.ruleForm.mobile,
        type:2
      }
      this.codeBusy = true
      try {
        const result = await this.sendVerifiedCode(param.mobile, param.type)
        if (!result || this.disposed) return
        this.showCode = 60
        this.times = setInterval(this.getCode2,1000)
      } catch (_) { /* The shared request handler displays the error. */ }
      finally { this.codeBusy = false }
    },
    handleClick(){
      this.$router.push('/Login').catch(err=>{})
    },
    async submitForm(formName) {
      if (this.submitting || this.codeBusy) return
      this.submitting = true
      try {
        const valid = await new Promise(resolve => this.$refs[formName].validate(resolve))
        if (valid) {
          await apiForget(this.ruleForm).then((res) => {
            if (!res) return
            this.$alert('密码重置成功，请重新登录', '提示', {
              confirmButtonText: '确定',
              callback: action => {
                Router.push('/login').catch(err=>{})
              }
            });
          }).catch(() => {})
        } /*else {
          console.log('error submit!!');
          return false;
        }*/
      } finally { this.submitting = false }
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  }
}
</script>
